import React, { useCallback, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, EmailNodeIcon, IconMobileNode, PDFNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { MobileNodePropsTypes } from "./FlowchartTypes";

const MobileNode: React.FC<MobileNodePropsTypes> = ({ id, data }) => {
    
    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`mobile-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <IconMobileNode width='1.5rem'/>
            <span>{data.data.name} - (Dissemination)</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}  
            <Handle id='pdf-target-a' type='target' position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
            {/* <Handle id='pdf-source-a' type='source' position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}
        </div>
    );
};

export default MobileNode;
